// Navbar.jsx
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { openCalendly } from "./CalendlyWidget";

const links = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/#services" },
  { label: "Publications", href: "/publications" },
  { label: "Team", href: "/#team" },
  { label: "Testimonials", href: "/#testimonials" },
  { label: "Contact", href: "/#contact" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToHash = (hash) => {
    if (!hash) return;
    window.setTimeout(() => {
      const target = document.querySelector(hash);
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
  };

  const handleNavClick = (event, href) => {
    event.preventDefault();
    setMenuOpen(false);

    if (href.startsWith("/#")) {
      const hash = href.slice(1);
      if (location.pathname === "/") {
        scrollToHash(hash);
      } else {
        navigate(`/${hash}`);
      }
      return;
    }

    navigate(href);
  };

  useEffect(() => {
    if (location.hash) scrollToHash(location.hash);
  }, [location.pathname, location.hash]);

  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-slate-950/80 backdrop-blur-xl shadow-2xl shadow-black/20">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <a
          href="/"
          onClick={(event) => handleNavClick(event, "/")}
          className="flex min-w-0 items-center gap-3"
          //aria-label="Lion Pride Financial home"
        >
          <img src="/logo.png" alt="Lion Pride Financial" className="h-10 w-auto object-contain" />
          {/*<span className="hidden text-sm font-semibold tracking-wide text-slate-100 sm:inline">
            Lion Pride Financial
          </span>*/}
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="Primary navigation">
          {links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(event) => handleNavClick(event, link.href)}
              className="rounded-full px-4 py-2 text-sm font-medium text-slate-200 transition hover:bg-white/10 hover:text-cyan-200"
            >
              {link.label}
            </a>
          ))}
          <button
            type="button"
            onClick={openCalendly}
            className="ml-2 rounded-full bg-cyan-500 px-5 py-2 text-sm font-bold text-white shadow-lg shadow-cyan-950/40 transition hover:bg-cyan-400"
          >
            Book a Consultation
          </button>
        </nav>

        <button
          type="button"
          className="inline-flex items-center justify-center rounded-full border border-white/15 bg-white/10 p-2 text-white transition hover:bg-white/15 md:hidden"
          onClick={() => setMenuOpen((open) => !open)}
          aria-expanded={menuOpen}
          aria-label="Toggle navigation menu"
        >
          <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {menuOpen && (
        <nav className="border-t border-white/10 bg-slate-950/95 px-4 py-4 md:hidden" aria-label="Mobile navigation">
          <div className="mx-auto flex max-w-7xl flex-col gap-2">
            {links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(event) => handleNavClick(event, link.href)}
                className="rounded-2xl px-4 py-3 font-medium text-slate-100 transition hover:bg-white/10 hover:text-cyan-200"
              >
                {link.label}
              </a>
            ))}
            <button
              type="button"
              onClick={() => {
                setMenuOpen(false);
                openCalendly();
              }}
              className="mt-2 rounded-2xl bg-cyan-500 px-4 py-3 text-center font-bold text-white transition hover:bg-cyan-400"
            >
              Book a Consultation
            </button>
          </div>
        </nav>
      )}
    </header>
  );
}
